<template>
  <div id="app">
	  <b-navbar toggleable="lg" type="dark" variant="info">
	      <b-navbar-brand router link to="/">Un petit voc ?</b-navbar-brand>
		</b-navbar>
	    <router-view style="margin: 50px auto" />
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
/*  margin-top: 60px;*/
}
</style>
